import type { ReactNode } from 'react'

import { cn } from '@/lib/utils'

/**
 * A labelled group of fields within a wizard step. Two columns on anything wider than a phone,
 * because a capture form read one field per line makes an operator scroll through what they can
 * otherwise take in at a glance.
 */
export function StepSection({
  title,
  description,
  children,
  className,
}: {
  title: string
  description?: string
  children: ReactNode
  className?: string
}) {
  return (
    <section className="space-y-3">
      <div className="space-y-0.5">
        <h3 className="text-sm font-semibold text-heading">{title}</h3>
        {description ? <p className="text-xs text-muted">{description}</p> : null}
      </div>
      <div className={cn('grid gap-4 sm:grid-cols-2', className)}>{children}</div>
    </section>
  )
}
